import React from 'react';
import {useFormContext} from 'react-hook-form';
import {TForm} from '@src/components/_views/configurable/import-view/file-list/.types';
import useUniqueId from '@src/hooks/useUniqueId';
import Translate from '@src/components/Translate/Translate';
import {FieldPath} from 'react-hook-form/dist/types/path';

export default function InputNumberField(props: {
    name: FieldPath<TForm>,
    label: string,
    step?: number,
    min?: number,
    max?: number,
}) {
    const {
        name,
        label,
        step = 1,
        min = 0,
        max = 100,
    } = props;

    const {register, watch, setValue} = useFormContext<TForm>();
    const id = useUniqueId();

    const value = watch(name);

    return <div className="row align-items-center">
        <div className="col">
            <Translate
                    tag="label"
                    message={label}
                    className="col-form-label"
                    htmlFor={id}
            />
        </div>
        <div className="col input-group">
            <button
                    type="button"
                    className="btn btn-link"
                    disabled={!value || value <= min}
                    onClick={() => setValue(name, value == null ? min : (+value - step))}
            >
                <i className="fa fa-minus"></i>
            </button>
            <input
                    type="number"
                    className="form-control"
                    id={id}
                    step={step}
                    min={min}
                    max={max}
                    {...register(name, {
                        min,
                        max,
                        pattern: /\D+?/
                    })}
                    style={{width: '50px'}}
            />
            <button
                    type="button"
                    className="btn btn-link"
                    disabled={value != null && value >= max}
                    onClick={() => setValue(name, value == null ? max : (+value + step))}
            >
                <i className="fa fa-plus"></i>
            </button>
        </div>
    </div>;
}
